import baseRequest from "_core/baseRequest";

export default {
    getHoursReport: params => baseRequest.post("/courier/report/hour", params, true),

    getShiftsReport: params => baseRequest.post("/courier/report/shift", params, true),

    getShiftEditLogsReport: params =>
        baseRequest.post("/shifts/reports/shift-edit-logs", params, true),

    /* havuz bolgesine ait vardiya raporunu listeler */
    poolShiftsReport: props => baseRequest.post(`poolshifts/listPoolShiftReports`, props, true),

    getDailyShiftsReport: params => baseRequest.post("/courier/report/dailyreport", params, true),

    getFeedbacksReport: params => baseRequest.post("/courier/report/feedback", params, true),

    getSubCompaniesReport: params => baseRequest.post("/courier/report/subcompanies", params, true),

    getUserReport: params => baseRequest.post("/users/reports/panelusers", params, true),

    getSubcompanyContracts: params => baseRequest.post(`subcompany/report/contract`, params, true),

    getDedicationsReport: params => baseRequest.post("/courier/report/dedication", params, true),

    getCourierReport: params => baseRequest.post("/courier/report/courier-report", params, true),

    getSubCompanySalesReport: params =>
        baseRequest.post(`/subcompany/report/subCompanyDetail`, params, true),

    getDeliveryOrdersReport: params => baseRequest.post("/delivery/orders-report", params, true)
};
